module.exports = __webpack_public_path__ + "static/media/gb.05e392da.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gb.svg
// module id = 2094
// module chunks = 0